/* ============================================================
   MAHER SHOES — Shared JavaScript
   maher.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile nav ----
  window.openMobileNav = function () {
    const nav = document.getElementById('mobileNav');
    if (!nav) return;
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  window.closeMobileNav = function () {
    const nav = document.getElementById('mobileNav');
    if (!nav) return;
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // ---- Sticky header: flip to solid after scrolling past the top ----
  const header = document.getElementById('siteHeader');
  if (header) {
    const updateScrolled = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    updateScrolled();
    window.addEventListener('scroll', updateScrolled, { passive: true });
  }

  // ---- Escape key closes overlays ----
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      window.closeMobileNav();
      if (window.closeFilters) window.closeFilters();
      closeAllMegamenus();
    }
  });

  // ---- Desktop megamenu (JS-driven hover + click toggle) ----
  const megaItems = document.querySelectorAll('.nav-item--mega');
  let megaCloseTimer = null;

  function setMegaOpen(item, open) {
    item.classList.toggle('is-open', open);
    const btn = item.querySelector('.header-nav__link');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }
  function closeAllMegamenus(except) {
    megaItems.forEach(item => {
      if (item === except) return;
      setMegaOpen(item, false);
    });
  }
  function openMega(item) {
    clearTimeout(megaCloseTimer);
    closeAllMegamenus(item);
    setMegaOpen(item, true);
  }
  function scheduleCloseAll() {
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(() => closeAllMegamenus(), 140);
  }

  const supportsHover = window.matchMedia('(hover: hover)').matches;

  megaItems.forEach(item => {
    const trigger = item.querySelector('.header-nav__link');
    if (!trigger) return;

    // Hover: open immediately, close after short delay so users can cross the gap.
    // Skip on touch-only devices to avoid synthesized mouseenter racing with click and toggling the menu closed.
    if (supportsHover) {
      item.addEventListener('mouseenter', () => openMega(item));
      item.addEventListener('mouseleave', scheduleCloseAll);
    }

    // Click / keyboard toggle (also handles touch)
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const isOpen = item.classList.contains('is-open');
      if (isOpen) {
        setMegaOpen(item, false);
      } else {
        openMega(item);
      }
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav-item--mega')) closeAllMegamenus();
  });

  // ---- Mobile nav accordion sections ----
  document.querySelectorAll('.mobile-nav__section-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('.mobile-nav__section');
      if (!section) return;
      const wasOpen = section.classList.contains('is-open');
      section.classList.toggle('is-open', !wasOpen);
      trigger.setAttribute('aria-expanded', String(!wasOpen));
    });
  });

  // ---- Accordion ----
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const wasOpen = item.classList.contains('is-open');
      // Close siblings in same group if desired
      const parent = item.closest('.accordion-group--exclusive');
      if (parent) {
        parent.querySelectorAll('.accordion-item').forEach(i => {
          i.classList.remove('is-open');
          const t = i.querySelector('.accordion-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
      if (!wasOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ---- Product tabs ----
  document.querySelectorAll('.product-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const group = tab.closest('[role="tablist"]');
      if (group) {
        group.querySelectorAll('.product-tab').forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
      }
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
    });
  });

  // ---- Quick-add buttons ----
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const orig = btn.textContent;
      btn.textContent = 'Added ✓';
      btn.style.background = 'var(--color-accent)';
      setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 1800);
    });
  });

  // ---- Announcement bar close ----
  document.querySelectorAll('.announcement-bar__close').forEach(btn => {
    btn.addEventListener('click', () => {
      const bar = btn.closest('.announcement-bar');
      if (bar) bar.style.display = 'none';
    });
  });

  // ---- FAQ accordion search (faq.html) ----
  const faqSearch = document.getElementById('faqSearch');
  if (faqSearch) {
    faqSearch.addEventListener('input', function () {
      const q = this.value.toLowerCase();
      document.querySelectorAll('.faq-item').forEach(item => {
        const text = item.textContent.toLowerCase();
        item.style.display = text.includes(q) || q === '' ? '' : 'none';
      });
    });
  }

  // ---- Track order form ----
  const trackForm = document.getElementById('trackOrderForm');
  if (trackForm) {
    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const result = document.getElementById('trackResult');
      if (result) {
        result.style.display = 'block';
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  // ---- Contact form ----
  const contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const success = document.getElementById('contactSuccess');
      if (success) {
        success.style.display = 'block';
        contactForm.style.display = 'none';
        success.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  // ---- Size tab switching (size-guide.html) ----
  document.querySelectorAll('.size-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.target;
      document.querySelectorAll('.size-tab-btn').forEach(b => b.classList.remove('is-active'));
      document.querySelectorAll('.size-table-panel').forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      const panel = document.getElementById(target);
      if (panel) panel.classList.add('is-active');
    });
  });

  // ---- Store map tab switching (stores.html) ----
  document.querySelectorAll('.store-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.store-tab-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // ---- Cart drawer ----
  (function initCartDrawer() {
    const SECTION_ID = 'cart-drawer';
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let lastFocus = null;
    let busy = false;

    function setHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
        if (count > 0) { el.removeAttribute('hidden'); }
        else { el.setAttribute('hidden', ''); }
      });
    }

    function syncCountFromDrawer() {
      const el = drawer.querySelector('[data-cart-total-count]');
      const count = el ? (parseInt(el.getAttribute('data-cart-total-count'), 10) || 0) : 0;
      setHeaderCount(count);
    }

    window.openCartDrawer = function () {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn && closeBtn.focus) { try { closeBtn.focus(); } catch (e) {} }
    };

    window.closeCartDrawer = function () {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    };

    // Swap only the inner markup so the open/close state on the wrapper survives.
    function applySections(sections) {
      if (!sections || typeof sections !== 'object') return false;
      const html = sections[SECTION_ID];
      if (typeof html !== 'string') return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-drawer-inner]');
      const current = drawer.querySelector('[data-cart-drawer-inner]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        syncCountFromDrawer();
        return true;
      }
      return false;
    }

    async function refreshDrawer() {
      try {
        const res = await fetch(rootUrl + '?sections=' + SECTION_ID, { headers: { 'Accept': 'application/json' } });
        const data = await res.json();
        applySections(data);
      } catch (e) { /* leave existing markup in place */ }
    }

    async function mutate(url, body) {
      if (busy) return;
      busy = true;
      drawer.classList.add('is-updating');
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(Object.assign({ sections: SECTION_ID }, body))
        });
        const data = await res.json();
        if (!applySections(data.sections)) {
          if (typeof data.item_count === 'number') setHeaderCount(data.item_count);
          await refreshDrawer();
        }
      } catch (e) {
        await refreshDrawer();
      } finally {
        busy = false;
        drawer.classList.remove('is-updating');
      }
    }

    function changeLine(key, quantity) {
      return mutate(rootUrl + 'cart/change.js', { id: key, quantity: quantity });
    }

    async function addToCart(form) {
      const btn = form.querySelector('[type="submit"]');
      const formData = new FormData(form);
      formData.append('sections', SECTION_ID);
      if (btn) btn.classList.add('is-loading');
      try {
        const res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        const data = await res.json();
        if (!res.ok) { form.submit(); return; }      // e.g. quantity unavailable — let Shopify show the error page
        if (!applySections(data.sections)) await refreshDrawer();
        window.openCartDrawer();
      } catch (e) {
        form.submit();                                // network failure — fall back to a normal POST
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    }

    // Open from the header cart icon (progressive enhancement over its href).
    document.querySelectorAll('[data-cart-toggle]').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        window.openCartDrawer();
        refreshDrawer();
      });
    });

    // Intercept add-to-cart submissions anywhere on the page.
    document.addEventListener('submit', e => {
      const form = e.target;
      if (!form.matches || !form.matches('form.pd-form, form[action$="/cart/add"]')) return;
      e.preventDefault();
      addToCart(form);
    });

    // Delegated controls inside the drawer (re-rendered content — must delegate).
    drawer.addEventListener('click', e => {
      const closeEl = e.target.closest('[data-cart-close]');
      if (closeEl) { e.preventDefault(); window.closeCartDrawer(); return; }

      const removeEl = e.target.closest('[data-cart-remove]');
      if (removeEl) {
        const item = removeEl.closest('[data-cart-item]');
        if (item) changeLine(item.dataset.key, 0);
        return;
      }

      const stepEl = e.target.closest('[data-qty-change]');
      if (stepEl) {
        const item = stepEl.closest('[data-cart-item]');
        const input = item && item.querySelector('[data-qty-input]');
        if (!item || !input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepEl.dataset.qtyChange, 10));
        changeLine(item.dataset.key, next);
      }
    });

    drawer.addEventListener('change', e => {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const item = input.closest('[data-cart-item]');
      if (!item) return;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(item.dataset.key, qty);
    });

    // Escape closes the drawer.
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') window.closeCartDrawer();
    });
  })();

});
